import env from './env'

export const CODE_QUERY_PARAM = 'oobCode'

export const MODE_QUERY_PARAM = 'mode'

export const CONTINUE_URL_QUERY_PARAM = 'continueUrl'

export const REAUTHENTICATE_QUERY_PARAM = 'reauthenticate'

export const SECURITY_QUERY_PARAM = 'changePassword'

export const DELETE_ACCOUNT_QUERY_PARAM = 'deleteAccount'

export const REAUTHENTICATION_STATUS_QUERY_PARAM = 'reauthenticationStatus'

export const REAUTHENTICATION_VARIANT_QUERY_PARAM = 'reauthenticationVariant'

export const EMAIL_FOR_SIGN_IN_STORAGE_KEY = 'emailForSignIn'

export const VIEWER_MODE_STORAGE_KEY = 'viewerMode'

export const SESSION_EXPIRY_HOLD_STORAGE_KEY = 'sessionExpiryHolds'

export const SESSION_AUTH_TIME_STORAGE_KEY = 'sessionAuthTime'

// Names of the 2FA factor saved in the user's Firebase account. Firebase may show
// them to the user. They differ by app, as the name is the only way to tell later
// which app the factor was added in.
export const BLUEBOLT_TOTP_FACTOR_DISPLAY_NAME = 'Blue Bolt Authenticator'

export const GLOBALWORTH_TOTP_FACTOR_DISPLAY_NAME =
  'Globalworth App Authenticator'

// App names shown next to the 2FA code in the authenticator app
export const BLUEBOLT_TOTP_ISSUER = 'BlueBolt'

export const GLOBALWORTH_TOTP_ISSUER = 'GlobalworthApp'

export const SYSTEM_ADMIN_SESSION_MAX_MS =
  env.systemAdminSessionMaxSeconds * 1000

export const USER_SESSION_MAX_MS = env.userSessionMaxSeconds * 1000

// The topbar shows the session countdown for this long before the session expires
export const SESSION_COUNTDOWN_MS = env.sessionCountdownSeconds * 1000

// A tab that keeps the other tabs from ending the session renews its hold this
// often, and the hold lasts this long, so the hold of a closed tab ends soon.
// It lasts over a minute, as a background tab may run its timers only once a minute.
export const SESSION_EXPIRY_HOLD_RENEWAL_MS = 30 * 1000

export const SESSION_EXPIRY_HOLD_DURATION_MS = 2 * 60 * 1000

// How long an expired session is kept for a reauthentication in progress, on
// the reauthentication screen or in the session extension dialog. Then every
// tab ends it, so a tab left open can't keep the others signed in for good.
export const SESSION_EXPIRY_GRACE_PERIOD_MS = 10 * 60 * 1000
